import { AUTH, LOGOUT, LOGIN_ERROR } from "../constants/actionTypes";
import secureLocalStorage from "react-secure-storage";
import { ADMIN_PROFILE_KEY } from "../Utils/actingBranch";
const authReducer = (
  state = {
    authData: null,
    resetSuccess: null,
    resetError: null,
    changePasswordSuccess: null,
    changePasswordError: null,
    emailSent: null,
    emailSentError: null,
  },
  action
) => {
  switch (action.type) {
    case LOGIN_ERROR:
      return { ...state, authData: action?.dataError };
    case AUTH: {
      // The token stays in the shared login cookie; keeping a copy here would
      // leave this app signed in after logging out from another app.
      const { token, ...profile } = action?.data || {};
      secureLocalStorage.setItem("profile", JSON.stringify(profile));
      secureLocalStorage.removeItem(ADMIN_PROFILE_KEY);
      return { ...state, authData: action?.data };
    }
    case LOGOUT:
      secureLocalStorage.clear();
      return { ...state, authData: null };
    case "RESET_USER_PASSWORD_SUCCESS":
      return { ...state, resetSuccess: action?.message };
    case "RESET_USER_PASSWORD_ERROR":
      return { ...state, resetError: action?.resetError };
    case "CHANGE_USER_PASSWORD_SUCCESS":
      return {
        ...state,
        changePasswordSuccess: action?.changeMessage,
        changePasswordError: null,
      };
    case "CHANGE_USER_PASSWORD_ERROR":
      return {
        ...state,
        changePasswordError: action?.changeError,
        changePasswordSuccess: null,
      };
    case "EMAIL_SENT_TO_USER":
      return {
        ...state,
        emailSent: action?.emailSentMessage,
        emailSentError: null,
      };
    case "EMAIL_SENDING_ERROR":
      return {
        ...state,
        emailSentError: action?.emailSendingError,
        emailSent: null,
      };

    default:
      return state;
  }
};

export default authReducer;
